// Per-app privacy policy data.
// Key = the URL slug used in /:appName/privacy-policy
// Add a new app by adding a new entry. Anything omitted falls back to defaults.

export const DEFAULT_POLICY = {
  lastUpdated: 'June 29, 2026',
  contactEmail: 'byte9962@gmail.com',
};

const policies = {
  notesgpt: {
    name: 'NotesGPT',
    lastUpdated: 'June 29, 2026',
    contactEmail: 'byte9962@gmail.com',

    intro:
      'This Privacy Policy explains how NotesGPT ("we", "our", or "us") collects, uses, and protects your information when you use the NotesGPT mobile application ("the App"). By using the App, you agree to the collection and use of information in accordance with this policy.',

    collect: `We collect the following types of information:

• Account Information: When you register, we collect your username and email address. Passwords are hashed and never stored in plain text.

• Uploaded Content: Files, documents, and images you upload to the App, including the text extracted from them.

• Chat Messages: Questions and messages you type in the AI chat feature.

• Usage Data: Information about how you use the App, such as features accessed and frequency of use, stored locally and on our servers to enforce free-tier limits.

• Device Information: Device type and operating system version, collected by third-party analytics and advertising services.

• Purchase Information: Subscription status managed through Apple App Store and Google Play via RevenueCat. We do not store payment card details.`,

    use: `We use the information we collect to:

• Provide, operate, and maintain the App's features (AI chat, flashcard generation, quiz generation).
• Process and retrieve your uploaded notes.
• Manage your account and subscription status.
• Enforce free-tier usage limits.
• Display relevant advertisements to free-tier users via Google AdMob.
• Improve app performance and fix bugs.
• Respond to your support requests.`,

    thirdParty: `NotesGPT shares data with the following third-party services to provide its features:

• Google Gemini (Google LLC) — AI processing service. Text content from your uploaded notes and your chat messages are sent to Google Gemini solely to generate flashcards, quiz questions, and AI chat responses. Google does not use this data to train its AI models. Learn more: https://policies.google.com/privacy

• RevenueCat — Subscription management. Your app user ID and subscription status are shared with RevenueCat to manage and verify your subscription. Learn more: https://www.revenuecat.com/privacy

• Google AdMob (Google LLC) — Advertising. Free-tier users may see ads served by Google AdMob. AdMob may collect device identifiers and usage data for ad personalization, subject to your App Tracking Transparency (ATT) consent on iOS. Learn more: https://policies.google.com/privacy

• Firebase (Google LLC) — File storage. Uploaded images are stored in Firebase Storage. Learn more: https://firebase.google.com/support/privacy

• Vercel — Backend hosting. Our API servers are hosted on Vercel. Data transmitted to our backend passes through Vercel's infrastructure. Learn more: https://vercel.com/legal/privacy-policy

We do not sell your personal data to any third party.`,

    deletion: `You may delete individual notes at any time from within the App by long-pressing a file. To request complete deletion of your account and all associated data, email us at byte9962@gmail.com with the subject line "Data Deletion Request".`,

    advertising: `Free-tier users may see banner and interstitial advertisements served by Google AdMob. On iOS, we request your permission via the App Tracking Transparency (ATT) prompt before serving personalized ads. You may opt out of personalized ads at any time in your device settings:

• iOS: Settings → Privacy & Security → Tracking
• Android: Settings → Google → Ads → Opt out of Ads Personalization`,

    security: `We take reasonable technical and organizational measures to protect your data, including encrypted data transmission (HTTPS) and hashed password storage. However, no method of transmission over the internet or electronic storage is 100% secure. We cannot guarantee absolute security.`,

    children: `NotesGPT is not directed to children under the age of 13. We do not knowingly collect personal information from children under 13. If you believe a child under 13 has provided us with personal data, please contact us and we will delete it promptly.`,

    changes: `We may update this Privacy Policy from time to time. We will notify you of any significant changes by updating the "Last Updated" date at the top of this page. Continued use of the App after changes constitutes your acceptance of the updated policy.`,
  },
};

export default policies;
